import { useCallback, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { FavoriteMarketWithNewGoods } from 'shared/src/api/favoriteMarketService/getFavoriteMarketsWithNewGoods/types';

type LogClickMarketParams = {
  market: FavoriteMarketWithNewGoods;
  index: number;
  listId: string;
};

export const useLogClickMarket = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const clickedSnoRef = useRef<Set<number>>(new Set());

  return useCallback(
    ({ market, index, listId }: LogClickMarketParams) => {
      const isFirstClick = !clickedSnoRef.current.has(market.sno);
      clickedSnoRef.current.add(market.sno);

      logAnalyticsEvent({
        name: 'CLICK_MARKET',
        analytics: {
          LIST_ID: listId,
          INDEX: index,
          MARKET_SNO: market.sno.toString(),
          MARKET_NAME: market.name,
          NEW_COUNT_GOODS: market.new_goods_count,
          IS_FIRST_CLICK: isFirstClick ? '1' : '0',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
